import __request__ from "routing/request";
export function listPacks(title, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/metrics/packs", null, { "title": title }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function packsByIds(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/metrics/packs/byIds", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
